var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "productItem",
      staticClass: "buttons-bottom-header__product jsFavoriteProduct",
    },
    [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__thumbnail-link",
          attrs: { href: _vm.item.DETAIL_PAGE_URL },
        },
        [
          _c("v-picture", {
            attrs: {
              image: _vm.item.DETAIL_PICTURE,
              "add-class": "buttons-bottom-header__thumbnail-img",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("p", { staticClass: "buttons-bottom-header__title" }, [
        _c("a", {
          attrs: { href: _vm.item.DETAIL_PAGE_URL },
          domProps: { innerHTML: _vm._s(_vm.item.NAME) },
        }),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "buttons-bottom-header__delete-btn jsDeleteFavorite favorite active",
          on: {
            click: function ($event) {
              return _vm.deleteItem(_vm.item.ID)
            },
          },
        },
        [
          _c("img", {
            attrs: { src: "/local/front/dist/content/delete-button-icon.svg" },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }